import type { IAPIRoutes } from "../../../../config";

export type INotificationRepository = ReturnType<
  typeof NotificationRepositoryFactory
>;

export const NotificationRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, PUT } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getNotificationSetting: IGetNotificationSettingAPI = async () => {
    const response = GET(
      APIRoutes.apiGetNotificationSettings,
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
    return response;
  };

  const setNotificationSetting: ISetNotificationSettingAPI = async (
    payload
  ) => {
    const response = PUT(APIRoutes.apiPutNotificationSettings, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });
    return response;
  };

  return {
    getNotificationSetting,
    setNotificationSetting,
  };
};
